import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/toast/toast-container.component';
import { SessionExpiryModalComponent } from './shared/session-expiry-modal/session-expiry-modal.component';
import { ModalScrollLockService } from './core/services/modal-scroll-lock.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, SessionExpiryModalComponent],
  template: `
    <router-outlet />
    <app-toast-container />
    <app-session-expiry-modal />
  `,
})
export class AppComponent {
  title = 'Accounting';

  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      inject(ModalScrollLockService).init();
    }
  }
}
